import { Currency } from '@/core/currency/interfaces';

const TJS: Currency = {
    name: 'Tajikistani Somoni',
    demonym: 'Tajikistani',
    majorSingle: 'Somoni',
    majorPlural: 'Somoni',
    codeNumeric: '972',
    symbol: 'SM',
    symbolNative: 'SM',
    minorSingle: 'Diram',
    minorPlural: 'Diram',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'TJS',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default TJS;
